import React from "react";
import "./ForgotPassword.scss";
import { isValidEmail } from "../../UserManagement/AddNewUserModal/AddNewUserModal";
import { withRouter } from "react-router";

import { apolloClient } from "../../../index";
import { gql } from "@apollo/client";
import { notify } from "../../Notify/Notify";

export default withRouter(
  class ForgotPassword extends React.Component {
    state = {
      email: "",
    };

    hasValidValues = () => {
      return (
        this.state.email.trim().length > 0 &&
        isValidEmail(this.state.email.trim())
      );
    };

    onSubmitHandler = (e) => {
      e.preventDefault();

      const variables = {
        email: this.state.email,
      };

      apolloClient
        .mutate({
          mutation: gql`
            mutation SendResetPasswordEmail($email: String!) {
              sendResetPasswordEmail(email: $email) {
                success
                token
              }
            }
          `,
          variables: variables,
        })
        .then((result) => {
          if (result.data.sendResetPasswordEmail.success) {
            this.setState({
              email: "",
            });
            const title = "Success";
            const detail = "Email sent successfully to reset your password!";
            const type = "success";
            notify(title, detail, type);
          }
        })
        .catch((e) => {
          const title = "Error";
          const detail = "Please enter a valid email address!";
          const type = "error";
          notify(title, detail, type);
        });
    };

    signUpHandler = () => {
      this.props.history.push("/sign-up");
    };

    render() {
      return (
        <div className="forgot-password-container">
          <h3 className="title">Forgot Password</h3>
          <p className="sub-title">
            Enter your email address to reset your password. You may need to
            check your spam folder.
          </p>

          <form>
            <div className="form-groups">
              <div className="form-group">
                <label>Email Address*</label>
                <input
                  type="email"
                  maxLength="50"
                  value={this.state.email}
                  onChange={(e) => this.setState({ email: e.target.value })}
                  className={`form-control email ${
                    this.state.email && !isValidEmail(this.state.email)
                      ? "error-input"
                      : ""
                  }`}
                  placeholder="mark.g@gmail.com"
                />
                {this.state.email && !isValidEmail(this.state.email) ? (
                  <lable className="error">
                    Please enter a valid email eg:xyz@xyz.com
                  </lable>
                ) : null}
              </div>
            </div>

            <button
              className="btn-primary forgot-password-button"
              disabled={!this.hasValidValues()}
              type="submit"
              onClick={this.onSubmitHandler}
            >
              Submit
            </button>
          </form>
          <p className="sign-up-options">
            Don’t have an account?{" "}
            <span className="sign-up" onClick={this.signUpHandler}>
              SignUp
            </span>
          </p>
        </div>
      );
    }
  }
);
